import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "../multyhealth/api/api";

const AdminContext = createContext({
  admin: null,
  isLoading: true,
  authenticated: false,
  logout: () => { },
});

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const res = await apiClient.get("/administrators", {
          headers: {
            Authorization: `${localStorage.getItem("token") || ""}`,
          },
        });
        const loadedAdmin = res?.data?.data?.admin ?? null;
        setAdmin(loadedAdmin);
        setAuthenticated(true);
      } catch (error) {
        setAdmin(null);
        setAuthenticated(false);
      } finally {
        setIsAuthLoading(false);
      }
    };

    fetchAdmin();
  }, []);

  const logout = useCallback(() => {
    setAdmin(null);
    setAuthenticated(false);
  }, []);

  return (
    <AdminContext.Provider value={{ admin, isLoading: isAuthLoading, authenticated, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
